import logo from "../assets/image/20211007_120244.jpg";
import { NavLink, Link, useHistory } from "react-router-dom";
import Container from "../LogIn/Container";
import useAuthentication from "../hooks/useAuthentication";
import { useState } from "react";

import { useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { URL_ID, USER_TYPE } from "constants/constants.js";
export default function Header() {
  const history = useHistory();
  const User = useAuthentication();
  const auth = useContext(WithAuthentication);
  const [UserInformation, setUserInformation] = useState(User.getInfo());
  function changeUserInformation(newInfo) {
    return setUserInformation(newInfo);
  }

  window.onscroll = () => {
    if (!document.querySelector(".header-container .navbar-toggler").classList.contains("collapsed")) {
      document.querySelector(".header-container .navbar-toggler").classList.add("collapsed");
      document.querySelector(".header-container .navbar-collapse").classList.remove("show");
    }
  };
  return (
    <>
      {console.log(auth, "auth")}
      <div className="sticky-top header-container" style={{ height: 90 }}>
        <nav className="navbar navbar-expand-md navbar-light p-4 " style={{ backgroundColor: "white" }}>
          <div className="container ">
            <div className="d-flex">
              <button className="navbar-toggler me-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon" />
              </button>
              <div>
                <Link to="/">
                  <img className="logo" src={logo} alt="" />
                </Link>
              </div>
            </div>

            <div className="d-flex d-md-none">
              <div className="login login-button-container ms-4">
                <a href="#" className="text-decoration-none text-dark ">
                  {!auth.isLogged ? (
                    <span className=" size1" data-bs-toggle="modal" data-bs-target="#ModalNumber">
                      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                      </svg>{" "}
                    </span>
                  ) : (
                    <span>{auth.userInfo.fullName == "" ? "کاربر عزیز" : auth.userInfo.fullName}</span>
                  )}
                  {/* modal */}
                </a>
                {auth.isLogged && (
                  <span
                    className=" size1 mx-4"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      auth.logout();
                      history.push("/");
                    }}
                  >
                    خروج
                  </span>
                )}
              </div>
              <div className="order" style={{ marginRight: "auto" }}>
                <a href="#" className="text-decoration-none text-dark ">
                  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-receipt-cutoff" viewBox="0 0 16 16">
                    <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zM11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                    <path d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293 2.354.646zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118l.137-.274z" />
                  </svg>
                </a>
              </div>
            </div>

            <div className="collapse navbar-collapse " id="navbar">
              <ul className="navbar-nav ms-0">
                <li className="nav-item">
                  <NavLink to={URL_ID.mainPage.route} exact className="nav-link">
                    {URL_ID.mainPage.name}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={URL_ID.shop.route} exact className="nav-link">
                    {URL_ID.shop.name}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={URL_ID.tours.route} exact className="nav-link">
                    {URL_ID.tours.name}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={URL_ID.attractions.route} exact className="nav-link">
                    {URL_ID.attractions.name}
                  </NavLink>
                </li>
                {USER_TYPE.generalAdmin == auth.userInfo.userType && (
                  <li className="nav-item">
                    <NavLink to={URL_ID.adminManagement.route} exact className="nav-link">
                      {URL_ID.adminManagement.name}
                    </NavLink>
                  </li>
                )}
                {USER_TYPE.customer == auth.userInfo.userType && (
                  <li className="nav-item">
                    <NavLink to={URL_ID.customerDashboard.route} exact className="nav-link">
                      {URL_ID.customerDashboard.name}
                    </NavLink>
                  </li>
                )}
                {/* {addExtraButtons(auth.userInfo.accessLevel)} */}
              </ul>
              <div className="d-none d-md-flex ms-auto d-flex">
                <div className="login login-button-container ">
                  <a href="#" className="text-decoration-none text-dark ">
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                    </svg>
                    {!auth.isLogged ? (
                      <span className=" size1" data-bs-toggle="modal" data-bs-target="#ModalNumber">
                        ورود یا ثبت نام
                      </span>
                    ) : (
                      <span>{!auth.userInfo.fullName ? "کاربر عزیز" : auth.userInfo.fullName}</span>
                    )}
                    {/* modal */}
                  </a>
                  {auth.isLogged && (
                    <span
                      className=" size1 mx-4"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        auth.logout();
                        history.push("/");
                      }}
                    >
                      خروج
                    </span>
                  )}
                </div>
                <div className="order" style={{ marginRight: "auto" }}>
                  <a href="#" className="text-decoration-none text-dark ms-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-receipt-cutoff" viewBox="0 0 16 16">
                      <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zM11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                      <path d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293 2.354.646zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118l.137-.274z" />
                    </svg>
                    <span className=" size1">پیگیری سفارش</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <Container changeUserInformation={changeUserInformation} />
    </>
  );
}
